import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Print Services - Elm Street</title>
        <meta
          name="description"
          content="Increase client referrals, support your geographic farming area, and build your brand presence with done-for-you print marketing."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/print_services" />
        <meta property="og:title" content="Print Services - Elm Street" />
        <meta
          property="og:description"
          content="Increase client referrals, support your geographic farming area, and build your brand presence with done-for-you print marketing."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />



      <ExitModal>
      <div style={{padding:"25px"}}>
                <div style={{textAlign:"center", paddingBottom:"10px"}}> <Typography variant="h4" component="h2" style={{ color: "#333666", textAlign: "center", paddingBottom:"10px" }}>Take The 30-Day <br /><span style={{color:"#f69c26"}}>Marketing Challenge!</span></Typography>
                </div>
                <div style={{textAlign:"center", paddingBottom:"10px"}}>A free downloadable guide with Simple steps to elevate your marketing in less than 1-month.
                </div>
                
                <FormMini buttonText="accept the challenge" successMsg={<div style={{textAlign:"center"}}><Button variant="contained" color="secondary" href="/assets/30daymarketingchallenge.pdf">Download the PDF</Button></div>}
              formName="es2_marketing_challenge" listId="148009" utmOverride="exit_intent" />
                
         </div>
         <div style={{textAlign:"center"}}>
         <Image
                    src="/mcgo.jpg"
                    width="590px"
                    height="242px"
                    alt="30 Day Marketing Challenge FREE Guide"
                   
                  />
                  </div>
     </ExitModal>




      <div
        style={{
          backgroundImage: "url('printbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Print Services"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    print
                    <br />
                    <span style={{ color: mainTheme.palette.secondary.main }}>services</span>
                  </Typography>
                  <p>
                    Done-For-You, Best-In-Class
                    <br />
                    Content &amp; Design.
                  </p>
                  <Button variant="contained" color="secondary" href="#form">
                    request information
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div
          style={{
            marginTop: "75px",
            marginBottom: "55px",
            textAlign: "center",
          }}
        >
          <Grid container spacing={8}>
            <Grid item md={12} sm={12}>
              Increase client referrals, support your geographic farming area,
              <br />
              and build your brand presence with done-for-you print marketing.
            </Grid>
          </Grid>
        </div>
      </Container>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "3px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={4} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    direct mail
                    <br />
                  </span>{" "}
                  newsletters
                </Typography>
                <br />
                <span>
                  Stay-in-touch with past clients with a monthly eye-catching direct mail newsletter that's engaging,
                  informative and affordable. 100% branded to you.
                </span>
              </Grid>
              <Grid item md={8} sm={12} style={{ marginBottom: "-9px" }}>
                <div>
                  <Image
                    src="/print1.png"
                    width="1098px"
                    height="780px"
                    alt="Elm Street Print Services - Direct Mail Newsletters"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "65px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/print2.png"
                    width="595px"
                    height="565px"
                    alt="Elm Street Print Services - Business Cards"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>business</span>
                  <br />
                  cards
                </Typography>
                <br />
                <span>
                  High-quality, full-color business cards to represent you and your business. Work with one of our
                  designers to create a truly custom look.
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('esbg2.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "3px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "75px" }}>
            <Grid container spacing={8}>
              <Grid item md={4} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>
                    postcards
                    <br />
                  </span>{" "}
                  &amp; flyers
                </Typography>
                <br />
                <span>
                  <span style={{ color: "#ffffff" }}>
                    Deliver your message with full-color, double-sided postcards &amp; flyers. Work with one of our
                    designers to create a truly custom look or DIY.
                  </span>
                </span>
              </Grid>
              <Grid item md={8} sm={12} style={{ marginBottom: "-9px" }}>
                <div>
                  <Image
                    src="/print3.png"
                    width="1088px"
                    height="780px"
                    alt="Elm Street Print Services - Postcards &amp; Flyers"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "65px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/print4.png"
                    width="595px"
                    height="565px"
                    alt="Elm Street Print Services - Signs &amp; Riders"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>Signs &amp;</span>
                  <br />
                  riders
                </Typography>
                <br />
                <span>
                  Capture leads at the curb with
                  <br />
                  signs and riders that incorporate
                  <br />
                  custom text numbers and QR codes.
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('esbg3.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "3px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "75px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>
                    custom
                    <br />
                  </span>{" "}
                  requests
                </Typography>
                <br />
                <span>
                  <span style={{ color: "#ffffff" }}>
                    Looking for something unique for you and your business? We're here to help! Connect with a member of
                    our team to discuss your needs.
                  </span>
                </span>
              </Grid>
              <Grid item md={7} sm={12} style={{ marginBottom: "-9px" }}>
                <div>
                  <Image
                    src="/print5.jpg"
                    width="600px"
                    height="581px"
                    alt="Elm Street Print Services - Custom Requests"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              request information
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>Connect with our team to explore your unique needs.</strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      successUrl="thankyou-simplified"
                      listId="147993"
                      formName="es2_print_services"
                      fieldList={["first_name", "last_name", "email", "phone", "roll"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
